import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_URL, handleSendMessage } from "src/utilities";
import { useNotifications } from "@toolpad/core/useNotifications";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Alert,
  Divider,
  Box,
  CircularProgress,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { IResultPayment } from "src/interface/IResultPayment";

export default function ResultPay() {
  const [searchParams] = useSearchParams();
  const [resPay, setResPay] = React.useState<IResultPayment | null>(null);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotifications();
  const navigate = useNavigate();
  useEffect(() => {
    const authority = searchParams.get("Authority");
    const status = searchParams.get("Status");

    if (status === "OK" && authority) {
      setLoading(true);
      axios
        .post(API_URL + "zarinpal/verify", {
          authority: authority,
        })
        .then((response) => {
          setResPay(response.data);
          handleSendMessage(notify, "پرداخت با موفقیت تأیید شد", "success");
        })
        .catch((error) => {
          setResPay({ message: "خطا در تأیید پرداخت", status: "FAILED" });
          handleSendMessage(notify, "خطا در تأیید پرداخت", "error");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setResPay({
        message: "پارامترهای معتبر ارائه نشده‌اند",
        status: "FAILED",
      });
      handleSendMessage(
        notify,
        "خطا: پارامترهای معتبر ارائه نشده‌اند",
        "error"
      );
    }
  }, [searchParams, notify]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        padding: 2,
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <Card
          sx={{
            maxWidth: 600,
            width: "100%",
            boxShadow: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <CardContent>
            {/* هدر رسید */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 2,
                backgroundColor:
                  searchParams.get("Status") === "OK"
                    ? "success.main"
                    : "error.main",
                color: "white",
              }}
            >
              {searchParams.get("Status") === "OK" ? (
                <CheckCircleIcon sx={{ fontSize: 40, mr: 1 }} />
              ) : (
                <ErrorIcon sx={{ fontSize: 40, mr: 1 }} />
              )}
              <Typography variant="h5" fontWeight="bold">
                {searchParams.get("Status") === "OK"
                  ? "پرداخت موفق"
                  : "پرداخت ناموفق"}
              </Typography>
            </Box>

            {/* پیام اصلی */}

            {/* جزئیات پرداخت */}
            {resPay && (
              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom>
                  جزئیات پرداخت به تکنو حساب
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2}>
                  {resPay.amount && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1" color="text.secondary">
                        مبلغ:
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {Math.floor(resPay.amount).toLocaleString()} ريال
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" color="text.secondary">
                      تاریخ پرداخت:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {new Date().toLocaleDateString("fa-IR")}
                    </Typography>
                  </Grid>
                  {resPay.refId && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1" color="text.secondary">
                        کد رهگیری:
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {resPay.refId}
                      </Typography>
                    </Grid>
                  )}
                  {resPay.cardPan && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1" color="text.secondary">
                        شماره کارت:
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{ dir: "rtl" }}
                      >
                        {resPay.cardPan}
                      </Typography>
                    </Grid>
                  )}

                  {resPay.status && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1" color="text.secondary">
                        وضعیت:
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {searchParams.get("Status") === "OK"
                          ? "موفق"
                          : "ناموفق"}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography textAlign="center">
                  از اعتماد و همراهی شما صمیمانه متشکریم.😊
                  <br />
                  جزئیات کامل تراکنش در صورتحساب قابل مشاهده است.
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => navigate("/pay/" + resPay.customerRef)}
                  sx={{ mt: 2 }}
                >
                  بازگشت به صورت حساب
                </Button>
              </Box>
            )}
          </CardContent>
        </Card>
      )}
    </Box>
  );
}
